import ReactPlayer from 'react-player'
import {
    AboutContainer,
    RowOneContainer,
    TopLine,
    VideoWrapper,
    NavBtnLink
} from './VideoElements'
import { FormButton } from '../BetaModalForms/BetaModalElements'

const VideoPlayer = () => {

    return (
        <AboutContainer>

            <NavBtnLink to='/signin?ds=true'>Demo Login</NavBtnLink>
            <RowOneContainer>
                <VideoWrapper>
                    <ReactPlayer
                        className='react-player'
                        src={require('../../videos/demo.mp4')}
                        width='100%'
                        height='100%'
                        controls={true}
                    />
                </VideoWrapper>
            </RowOneContainer>
        </AboutContainer>
    )
}

export default VideoPlayer